import Wrapper from "../../helpers/Wrapper";
import Loader from "../loaders/Loader";
import ErrorBoundary from "../../../utils/ErrorBoundary";
import ServerErrorsLoader from "../loaders/ServerErrosLoader";
import NoDataAvailableLoader from "../loaders/NoDataAvailable";

export const createWrapper = (children) => (
    <Wrapper>
        <ErrorBoundary>
            {children}
        </ErrorBoundary>
    </Wrapper>
);


export const createLoaderSection = (loaderType, title, variantType) =>
    createWrapper(
        <div className="grid grid_cols_4 grid_margin_bottom">
            <div className="grid col_span_4 section_header">
                <div className="section_info">  <h2 className="section_card_title">{title}
                </h2></div>

            </div>
            <div className="grid col_span_4 grid_margin_bottom">
                <Loader loaderType={loaderType} variantType={variantType} />
            </div>
        </div>
    );

export const createErrorLoaderSection = (loaderType) =>
    createWrapper(<ServerErrorsLoader chartType={loaderType} />);


export const createNoDataLoaderSection = (loaderType) =>
    createWrapper(<NoDataAvailableLoader chartType={loaderType} />);